import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/app/(commerce)/okul-albumleri/page.tsx");
